import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { RouteEnum } from '@app/constants/route.enum';
import { filter, fromEvent, map, merge, startWith } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class Network {
  private readonly router = inject(Router);
  private readonly platformId = inject(PLATFORM_ID);

  private lastOnlineUrl = '/';

  constructor() {
    if (!isPlatformBrowser(this.platformId)) return;
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        if (navigator.onLine && this.router.url !== RouteEnum.NO_INTERNET) {
          this.lastOnlineUrl = this.router.url;
        }
      });
    merge(
      fromEvent(globalThis, 'online').pipe(map(() => true)),
      fromEvent(globalThis, 'offline').pipe(map(() => false))
    )
      .pipe(startWith(navigator.onLine))
      .subscribe((isOnline) => {
        if (!isOnline && this.router.url !== RouteEnum.NO_INTERNET) {
          this.router.navigate([RouteEnum.NO_INTERNET]);
        }
        if (isOnline && this.router.url === RouteEnum.NO_INTERNET) {
          this.router.navigate([this.lastOnlineUrl]);
        }
      });
  }
}
